webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(310);

var _promise2 = _interopRequireDefault(_promise);

var _ApiConnector = __webpack_require__(284);

var _ApiConnector2 = _interopRequireDefault(_ApiConnector);

var _User = __webpack_require__(26);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiLocalStorage = {
  requestData: function requestData(name, apiUrl, method, data, time) {
    return new _promise2.default(function (resolve, reject) {
      if (localStorage.getItem(name) && new Date().getTime() - new Date(JSON.parse(localStorage.getItem(name)).time).getTime() <= time) {
        resolve(JSON.parse(localStorage.getItem(name)).result);
      } else {
        var apiConnector = new _ApiConnector2.default();
        apiConnector.request(method, apiUrl, data).then(function (response) {
          localStorage.setItem(name, (0, _stringify2.default)({ 'time': new Date().getTime(), 'result': response.data }));
          resolve(response.data);
        });
      }
    });
  },
  requestUserData: function requestUserData(name, apiUri) {
    return new _promise2.default(function (resolve, reject) {
      if (localStorage.getItem(name)) {
        var data = JSON.parse(localStorage.getItem(name));
        resolve(data);
      } else {
        var apiConnector = new _ApiConnector2.default();
        apiConnector.request('post', apiUri, '').then(function (response) {
          var licenses = [];
          var filteredLicenses = response.data.licenses.filter(function (row) {
            if (!licenses.includes(row.lic)) {
              licenses.push(row.lic);
              return row;
            }
          });
          localStorage.setItem(name, (0, _stringify2.default)({
            'lic': filteredLicenses[0].lic,
            'options': response.data.options,
            'licList': filteredLicenses
          }));
          resolve({ 'lic': response.data.licenses[0].lic, 'options': response.data.options });
        });
      }
    });
  },
  getUserLic: function getUserLic() {
    return new _User2.default().getLic();
  },
  getUserOptions: function getUserOptions() {
    return new _User2.default().getOptions();
  },
  getDateRange: function getDateRange() {
    if (localStorage.getItem('dateRange')) {
      return JSON.parse(localStorage.getItem('dateRange'));
    } else {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    }
  },
  setDateRange: function setDateRange(date) {
    localStorage.setItem('dateRange', (0, _stringify2.default)(date));
  }
};

exports.default = ApiLocalStorage;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(69);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(70);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var User = function () {
  function User() {
    var newUserData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck3.default)(this, User);

    if (newUserData != null) {
      this._saveUserDataToStorage(newUserData);
    } else {
      this._loadUserDataFromStorage();
    }
  }

  (0, _createClass3.default)(User, [{
    key: 'isUserAuth',
    value: function isUserAuth() {
      if (this.userAuthData != null) {
        return true;
      }

      return false;
    }
  }, {
    key: 'logout',
    value: function logout() {
      localStorage.removeItem('user');
      localStorage.removeItem('userDataOptions');
    }
  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      if (typeof this.userAuthData !== 'undefined' && this.userAuthData !== null) {
        return this.userAuthData.access_token;
      }
      return null;
    }
  }, {
    key: 'getLic',
    value: function getLic() {
      return JSON.parse(localStorage.getItem('userDataOptions')).lic;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return JSON.parse(localStorage.getItem('userDataOptions')).options;
    }
  }, {
    key: 'getRefreshToken',
    value: function getRefreshToken() {
      return this.userAuthData.refresh_token;
    }
  }, {
    key: 'getTokenExpiresTime',
    value: function getTokenExpiresTime() {
      return this.userAuthData.expires_in;
    }
  }, {
    key: '_saveUserDataToStorage',
    value: function _saveUserDataToStorage(userData) {
      userData.createdAt = new Date().getTime();
      localStorage.setItem('user', (0, _stringify2.default)(userData));
      this.userAuthData = userData;
    }
  }, {
    key: '_loadUserDataFromStorage',
    value: function _loadUserDataFromStorage() {
      if (localStorage.user) {
        this.userAuthData = JSON.parse(localStorage.user);
      }
    }
  }]);
  return User;
}();

exports.default = User;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _numberFormatter = function _numberFormatter(number) {
  try {
    return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,/g, ' ').replace('.', ',');
  } catch (e) {}
};
var _numberFormatterThousand = function _numberFormatterThousand(number) {
  try {
    return number.toLocaleString().replace(/,/g, ' ');
  } catch (e) {}
};

var GlobalMixins = {
  methods: {
    numberFormatter: function numberFormatter(number) {
      return _numberFormatter(number);
    },
    numberFormatterThousand: function numberFormatterThousand(number) {
      return _numberFormatterThousand(number);
    },
    getPermission: function getPermission(perm) {
      if (JSON.parse(localStorage.getItem('userDataOptions')) !== null && typeof JSON.parse(localStorage.getItem('userDataOptions')).options[perm] !== 'undefined') {
        return JSON.parse(localStorage.getItem('userDataOptions')).options[perm];
      }
      return false;
    }
  },
  filters: {
    filter: function filter(number) {
      return _numberFormatter(number);
    },
    thousandSep: function thousandSep(number) {
      return _numberFormatterThousand(number);
    }
  }
};

exports.default = GlobalMixins;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SideBar = __webpack_require__(435);

var _SideBar2 = _interopRequireDefault(_SideBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [{
    name: 'Szacunkowe wpłaty 1,5%',
    icon: 'ti-panel',
    path: '/panel/wplaty',
    child: true
  }, {
    name: 'Uruchomienia i Wypełnienia',
    icon: 'ti-panel',
    path: '/panel/uruchomienia-wypelnienia',
    child: true
  }, {
    name: 'Statystyki pobrań',
    icon: 'ti-view-list-alt',
    path: '/panel/statystyki-pobran',
    child: false
  }, {
    name: 'Statystyki deklaracji',
    icon: 'ti-view-list-alt',
    path: '/panel/statystyki-deklaracji',
    child: false
  }],
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', _SideBar2.default);
  }
};

exports.default = SidebarPlugin;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formGroupInput = __webpack_require__(434);

var _formGroupInput2 = _interopRequireDefault(_formGroupInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', _formGroupInput2.default);
  }
};

exports.default = GlobalComponents;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueClickaway = __webpack_require__(417);

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', _vueClickaway.directive);
  }
};

exports.default = GlobalDirectives;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(26);

var _User2 = _interopRequireDefault(_User);

var _GlobalMixins = __webpack_require__(41);

var _GlobalMixins2 = _interopRequireDefault(_GlobalMixins);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var user = new _User2.default();
var routesBeforeEach = function routesBeforeEach(to, from, next) {
  if (user.isUserAuth() === false) {
    user = new _User2.default();
  }
  if (user.isUserAuth() || to.path === '/login') {
    if ((to.path === '/panel/wplaty' || to.path === '/panel/statystyki-deklaracji') && _GlobalMixins2.default.methods.getPermission('hideAmounts')) {
      next({
        path: '/panel/uruchomienia-wypelnienia'
      });
    } else {
      next();
    }
  } else {
    next({
      path: '/login'
    });
  }
};
exports.default = routesBeforeEach;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DashboardLayout = __webpack_require__(420);

var _DashboardLayout2 = _interopRequireDefault(_DashboardLayout);

var _NotFoundPage = __webpack_require__(431);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _LoginPage = __webpack_require__(430);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _Overview = __webpack_require__(426);

var _Overview2 = _interopRequireDefault(_Overview);

var _Fillings = __webpack_require__(424);

var _Fillings2 = _interopRequireDefault(_Fillings);

var _UserProfile = __webpack_require__(427);

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _DownloadStats = __webpack_require__(423);

var _DownloadStats2 = _interopRequireDefault(_DownloadStats);

var _DeclarationsStats = __webpack_require__(422);

var _DeclarationsStats2 = _interopRequireDefault(_DeclarationsStats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  name: 'Dashboard',
  path: '/',
  component: _DashboardLayout2.default,
  redirect: '/panel/wplaty'
}, {
  path: '/login',
  component: _LoginPage2.default
}, {
  path: '/panel',
  component: _DashboardLayout2.default,
  redirect: '',
  children: [{
    path: 'wplaty',
    name: 'Szacunkowe wpłaty 1,5%',
    component: _Overview2.default
  }, {
    path: 'uruchomienia-wypelnienia',
    name: 'Uruchomienia i Wypełnienia',
    component: _Fillings2.default
  }, {
    path: 'stats',
    name: 'Profil użytkownika',
    component: _UserProfile2.default
  }, {
    path: 'statystyki-pobran',
    name: 'Statystyki pobrań',
    component: _DownloadStats2.default
  }, {
    path: 'statystyki-deklaracji',
    name: 'Statystyki deklaracji',
    component: _DeclarationsStats2.default
  }]
}, { path: '*', component: _NotFoundPage2.default }];

exports.default = routes;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(460);

var _vuex2 = _interopRequireDefault(_vuex);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    lic: ''
  },
  getters: {
    lic: function lic(state) {
      return state.lic;
    }
  },
  mutations: {
    changeLic: function changeLic(state, lic) {
      state.lic = lic;
    }
  },
  actions: {
    getLicenseChange: function getLicenseChange(_ref) {
      var commit = _ref.commit;

      commit('changeLic', _ApiLocalStorage2.default.getUserLic());
    }
  }
});

exports.default = store;

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__(412);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

var _GlobalMixins = __webpack_require__(41);

var _GlobalMixins2 = _interopRequireDefault(_GlobalMixins);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vueChartjs.Bar.extend({
  mixins: [_vueChartjs.mixins.reactiveData, _GlobalMixins2.default],
  data: function data() {
    return {
      disableOnline: false
    };
  },

  props: {
    range: '',
    url: '',
    time: '',
    localName: '',
    addMonths: {
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    type_from: {
      type: String,
      default: ''
    },
    amountValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    lic: function lic() {
      return this.$store.getters.lic;
    }
  },
  mounted: function mounted() {
    this.disableOnline = this.getPermission('disableOnline');
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          categoryPercentage: 1,
          barPercentage: 0.6,
          gridLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            borderDash: [6, 3]
          }
        }],
        yAxes: [{
          gridLines: {
            color: 'rgba(0,0,0,0.1)',
            display: true,
            borderDash: [6, 3]
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            if (this.amountValue) {
              return _GlobalMixins2.default.methods.numberFormatter(tooltipItem.yLabel);
            } else {
              return _GlobalMixins2.default.methods.numberFormatterThousand(tooltipItem.yLabel);
            }
          }
        }
      }
    });
  },

  watch: {
    range: function range() {
      if (this.range[0] !== null || this.range[1] !== null) {
        this.getData((0, _moment2.default)(this.range[0]).format('YYYY-MM-DD'), (0, _moment2.default)(this.range[1]).format('YYYY-MM-DD'));
      }
    },
    lic: function lic() {
      if (this.range[0] !== null || this.range[1] !== null) {
        this.getData((0, _moment2.default)(this.range[0]).format('YYYY-MM-DD'), (0, _moment2.default)(this.range[1]).format('YYYY-MM-DD'));
      }
    }
  },
  methods: {
    fillData: function fillData(keys, exe, online, sum) {
      var dataSets = [{
        label: 'Instalacyjna',
        backgroundColor: '#9ad0f5',
        data: exe,
        borderColor: '#51B4E5',
        borderWidth: 2
      }];
      if (!this.disableOnline) {
        dataSets.push({
          label: 'Online',
          backgroundColor: '#ffa1ab',
          data: online,
          borderColor: '#EE5A63',
          borderWidth: 2
        }, {
          label: 'Suma instalacyjna + online',
          data: sum,
          borderColor: '#41b883',
          borderWidth: 2,
          type: 'line'
        });
      }
      this.chartData = {
        labels: keys,
        datasets: dataSets
      };
    },
    getData: function getData(startDate, endDate) {
      var _this = this;

      this.$emit('loader', true);
      if (startDate <= endDate) {
        _ApiLocalStorage2.default.requestData(this.localName + startDate + ',' + endDate + this.lic, this.url, 'post', {
          'lic': this.lic,
          'period': startDate + ',' + endDate,
          'months': this.addMonths,
          'type': this.type,
          'type_from': this.type_from
        }, this.time).then(function (data) {
          _this.fillData(data.keys, data.values.exe, data.values.online, _this.sumExeOnline(data));
          _this.$nextTick(function () {
            _this.$emit('loader', false);
          });
        });
      }
    },
    sumExeOnline: function sumExeOnline(data) {
      var sum = [];
      for (var i = 0; i < data.values.exe.length; i++) {
        sum[i] = (data.values.exe[i] + data.values.online[i]).toFixed(2);
      }
      return sum;
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(69);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(70);

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = __webpack_require__(40);

var _axios2 = _interopRequireDefault(_axios);

var _User = __webpack_require__(26);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiConnector = function () {
  function ApiConnector() {
    (0, _classCallCheck3.default)(this, ApiConnector);

    var user = new _User2.default();
    if (user.isUserAuth()) {
      this.axios = _axios2.default.create({
        baseURL: "https://stats-api2024.pit-format-online.pl",
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + user.getAccessToken()
        }
      });
    }
  }

  (0, _createClass3.default)(ApiConnector, [{
    key: 'request',
    value: function request(method, url, data) {
      return this.axios({
        method: method,
        url: url,
        data: this._prepareRequestData(data)
      });
    }
  }, {
    key: '_prepareRequestData',
    value: function _prepareRequestData(data) {
      return data;
    }
  }]);
  return ApiConnector;
}();

exports.default = ApiConnector;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(242);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _globalComponents = __webpack_require__(229);

var _globalComponents2 = _interopRequireDefault(_globalComponents);

var _globalDirectives = __webpack_require__(230);

var _globalDirectives2 = _interopRequireDefault(_globalDirectives);

var _SidebarPlugin = __webpack_require__(228);

var _SidebarPlugin2 = _interopRequireDefault(_SidebarPlugin);

var _App = __webpack_require__(241);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(235);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(239);

var _routes = __webpack_require__(232);

var _routes2 = _interopRequireDefault(_routes);

var _beforeEach = __webpack_require__(231);

var _beforeEach2 = _interopRequireDefault(_beforeEach);

var _chartist = __webpack_require__(234);

var _chartist2 = _interopRequireDefault(_chartist);

__webpack_require__(238);

__webpack_require__(240);

__webpack_require__(237);

var _pl = __webpack_require__(236);

var _pl2 = _interopRequireDefault(_pl);

var _GlobalMixins = __webpack_require__(41);

var _GlobalMixins2 = _interopRequireDefault(_GlobalMixins);

var _store = __webpack_require__(233);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_globalComponents2.default);
_vue2.default.use(_globalDirectives2.default);
_vue2.default.use(_SidebarPlugin2.default);
_vue2.default.use(_elementUi2.default, { locale: _pl2.default });
_vue2.default.mixin(_GlobalMixins2.default);

window.axios = __webpack_require__(40);

var router = new _vueRouter2.default({
  routes: _routes2.default,
  linkActiveClass: 'active',
  mode: 'history'
});
router.beforeEach(_beforeEach2.default);

Object.defineProperty(_vue2.default.prototype, '$Chartist', {
  get: function get() {
    return this.$root.Chartist;
  }
});

new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  },
  router: router,
  store: _store2.default,
  data: {
    Chartist: _chartist2.default
  }
});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopNavbar = __webpack_require__(421);

var _TopNavbar2 = _interopRequireDefault(_TopNavbar);

var _ContentFooter = __webpack_require__(419);

var _ContentFooter2 = _interopRequireDefault(_ContentFooter);

var _Content = __webpack_require__(418);

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TopNavbar: _TopNavbar2.default,
    ContentFooter: _ContentFooter2.default,
    DashboardContent: _Content2.default
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _User = __webpack_require__(26);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    routeName: function routeName() {
      var name = this.$route.name;

      return this.capitalizeFirstLetter(name);
    },
    lic: function lic() {
      return this.$store.getters.lic;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getLicenseChange');
    this.license = this.$store.getters.lic;
    this.licenses = JSON.parse(localStorage.getItem('userDataOptions')).licList;
  },
  data: function data() {
    return {
      license: '',
      activeNotifications: false,
      licenses: Array,
      licName: ''
    };
  },

  watch: {
    lic: function lic() {
      this.$notify({
        message: 'Wybrana licencja ' + this.license,
        type: 'info'
      });
      this.licName = this.licenseName();
    }
  },
  methods: {
    licenseName: function licenseName() {
      for (var i = 0; i < this.licenses.length; i++) {
        if (this.licenses[i].lic === this.lic) {
          return this.licenses[i].name !== null ? this.licenses[i].name.Nazwa : '';
        }
      }
    },
    checkLicensesLength: function checkLicensesLength() {
      return this.licenses.length > 1;
    },
    onLogout: function onLogout() {
      var user = new _User2.default();
      user.logout();
      this.$router.push('/login');
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    changeLicense: function changeLicense(value) {
      this.$store.commit('changeLic', value);
    }
  }
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(68);

var _values2 = _interopRequireDefault(_values);

var _DeclarationsTable = __webpack_require__(432);

var _DeclarationsTable2 = _interopRequireDefault(_DeclarationsTable);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _JsonExcel = __webpack_require__(226);

var _JsonExcel2 = _interopRequireDefault(_JsonExcel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      jsonData: [],
      month: '',
      loader: false,
      tableDataExeOnline: [],
      tableDataExe: [],
      tableDataOnline: [],
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec'],
      sumRows: [],
      dateRange: '',
      datePeriod: '',
      excelDate: '',
      correction: false,
      sum: {},
      json_fields1: {
        'Instalacyjna-kwoty': 8,
        'Instalacyjna-wypelnienia': 7
      },
      json_fields2: ['Dzien', 'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma', 'PIT-28', 'PIT-36', 'PIT-36L', 'PIT-37', 'PIT-38', 'PIT-39', 'Suma'],
      disableOnline: false
    };
  },
  mounted: function mounted() {
    this.disableOnline = this.getPermission('disableOnline');
    this.loader = true;
    this.changeDatePeriod(0);
  },

  computed: {
    lic: function lic() {
      return this.$store.getters.lic;
    }
  },
  watch: {
    lic: function lic() {
      this.changeDatePeriod(this.month);
    }
  },
  components: { DeclarationsTable: _DeclarationsTable2.default, JsonExcel: _JsonExcel2.default },
  methods: {
    getTableData: function getTableData() {
      var _this = this;

      this.loader = true;

      _ApiLocalStorage2.default.requestData('tableDec' + this.datePeriod + this.correction + this.lic, 'api/legacy/upo-dec', 'post', {
        'lic': this.lic,
        'period': this.datePeriod,
        'correction': this.correction
      }, 900000).then(function (response) {
        _this.excelDate = _this.datePeriod;
        _this.tableDataOnline = response.values.online;
        _this.tableDataExe = response.values.exe;
        _this.tableDataExeOnline = _this.sumTables(_this.tableDataExe, _this.tableDataOnline);
        _this.prepareExportData();
        setTimeout(function () {
          _this.loader = false;
        }, 1);
      });
    },
    dateChange: function dateChange(date) {
      this.changeDatePeriod(date, 1);
    },
    changeDatePeriod: function changeDatePeriod(date) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (range === 1) {
        this.datePeriod = date;
      } else {
        this.month = date;
        var firstDay = new Date(new Date().getFullYear(), date, 1);
        var lastDay = new Date(new Date().getFullYear(), date + 1, 0);
        this.datePeriod = (0, _moment2.default)(firstDay).format('YYYY-MM-DD') + ',' + (0, _moment2.default)(lastDay).format('YYYY-MM-DD');
      }
      this.getTableData();
    },
    sumTables: function sumTables(exe, online) {
      var sumTable = [];
      for (var i = 0; i < exe.length; i++) {
        sumTable[i] = {
          day: exe[i].day,
          fills: {
            'PIT-28': exe[i].fills['PIT-28'] + online[i].fills['PIT-28'],
            'PIT-36': exe[i].fills['PIT-36'] + online[i].fills['PIT-36'],
            'PIT-36L': exe[i].fills['PIT-36L'] + online[i].fills['PIT-36L'],
            'PIT-37': exe[i].fills['PIT-37'] + online[i].fills['PIT-37'],
            'PIT-38': exe[i].fills['PIT-38'] + online[i].fills['PIT-38'],
            'PIT-39': exe[i].fills['PIT-39'] + online[i].fills['PIT-39']
          },
          amounts: {
            'PIT-28': exe[i].amounts['PIT-28'] + online[i].amounts['PIT-28'],
            'PIT-36': exe[i].amounts['PIT-36'] + online[i].amounts['PIT-36'],
            'PIT-36L': exe[i].amounts['PIT-36L'] + online[i].amounts['PIT-36L'],
            'PIT-37': exe[i].amounts['PIT-37'] + online[i].amounts['PIT-37'],
            'PIT-38': exe[i].amounts['PIT-38'] + online[i].amounts['PIT-38'],
            'PIT-39': exe[i].amounts['PIT-39'] + online[i].amounts['PIT-39']
          }
        };
      }
      return sumTable;
    },
    calculateRowSums: function calculateRowSums(data, dataType) {
      var sumTable = [];
      var i = 0;
      data.forEach(function (value) {
        sumTable[i] = value[dataType]['PIT-28'] + value[dataType]['PIT-37'] + value[dataType]['PIT-36'] + value[dataType]['PIT-36L'] + value[dataType]['PIT-38'] + value[dataType]['PIT-39'];
        i++;
      });
      return sumTable;
    },
    calculateSum: function calculateSum(data, dataType) {
      var sum = { pit28: 0, pit36: 0, pit36l: 0, pit37: 0, pit38: 0, pit39: 0, summary: 0 };
      data.forEach(function (value) {
        sum.pit28 += value[dataType]['PIT-28'];
        sum.pit36 += value[dataType]['PIT-36'];
        sum.pit36l += value[dataType]['PIT-36L'];
        sum.pit37 += value[dataType]['PIT-37'];
        sum.pit38 += value[dataType]['PIT-38'];
        sum.pit39 += value[dataType]['PIT-39'];
      });
      this.calculateRowSums(data, dataType).forEach(function (value) {
        sum.summary += value;
      });
      return sum;
    },
    prepareExportData: function prepareExportData() {
      var exe = this.tableDataExe;
      var rowSumExeFills = this.calculateRowSums(this.tableDataExe, 'fills');
      var rowSumExeAmounts = this.calculateRowSums(this.tableDataExe, 'amounts');
      var sumAll = (0, _values2.default)(this.calculateSum(this.tableDataExe, 'amounts'));
      sumAll = sumAll.concat((0, _values2.default)(this.calculateSum(this.tableDataExe, 'fills')));
      var dataAll = [];
      for (var i = 0; i < this.tableDataExe.length; i++) {
        dataAll[i] = [exe[i].day, exe[i]['amounts']['PIT-28'], exe[i]['amounts']['PIT-36'], exe[i]['amounts']['PIT-36L'], exe[i]['amounts']['PIT-37'], exe[i]['amounts']['PIT-38'], exe[i]['amounts']['PIT-39'], rowSumExeAmounts[i], exe[i]['fills']['PIT-28'], exe[i]['fills']['PIT-36'], exe[i]['fills']['PIT-36L'], exe[i]['fills']['PIT-37'], exe[i]['fills']['PIT-38'], exe[i]['fills']['PIT-39'], rowSumExeFills[i]];
      }
      for (var _i = 0; _i < dataAll.length; _i++) {
        for (var j = 0; j < dataAll[_i].length; j++) {
          dataAll[_i][j] = this.numberFormatter(dataAll[_i][j]);
        }
      }
      for (var _i2 = 0; _i2 < sumAll.length; _i2++) {
        sumAll[_i2] = this.numberFormatter(sumAll[_i2]);
      }
      sumAll.splice(0, 0, 'Suma');
      dataAll.push(sumAll);
      this.jsonData = dataAll;
    }
  }
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(68);

var _values2 = _interopRequireDefault(_values);

var _DownloadTable = __webpack_require__(433);

var _DownloadTable2 = _interopRequireDefault(_DownloadTable);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _JsonExcel = __webpack_require__(226);

var _JsonExcel2 = _interopRequireDefault(_JsonExcel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tableColumns = ['date', 'download', 'first', 'strong', 'fills', 'amount'];
var columnsNames = ['Dzień', 'Pobrania', 'Pierwsze uruchomienia', 'Strong', 'Wypełnienie', 'Kwota'];
exports.default = {
  components: {
    DownloadTable: _DownloadTable2.default, JsonExcel: _JsonExcel2.default
  },
  data: function data() {
    return {
      jsonData: [],
      month: '',
      loader: false,
      tableDataExe: [],
      tableDataOnline: [],
      tableDataExeOnline: [],
      table1: {
        title: 'Instalacyjna',
        subTitle: 'Here is a subtitle for this table',
        columns: [].concat(tableColumns),
        data: this.tableData,
        names: [].concat(columnsNames)
      },
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec'],
      dateRange: '',
      excelDate: '',
      json_fields1: {
        'Instalacyjna': 6
      },
      json_fields2: ['Dzien', 'Pobr.', 'Pierwsze Uruch.', 'Uruch. Twarde', 'Wyp', 'Kwota'],
      disableOnline: false
    };
  },
  mounted: function mounted() {
    this.disableOnline = this.getPermission('disableOnline');
    this.loader = true;
    this.getTableData(0);
  },

  computed: {
    lic: function lic() {
      return this.$store.getters.lic;
    }
  },
  watch: {
    lic: function lic() {
      this.getTableData(this.month);
    }
  },
  methods: {
    getExcelPermission: function getExcelPermission() {
      return this.getPermission('hideAmounts');
    },
    getTableData: function getTableData(date, range) {
      var _this = this;

      this.loader = true;
      if (range !== 1) {
        this.month = date;

        var firstDay = new Date(new Date().getFullYear(), date, 1);
        var lastDay = new Date(new Date().getFullYear(), date + 1, 0);
        date = (0, _moment2.default)(firstDay).format('YYYY-MM-DD') + ',' + (0, _moment2.default)(lastDay).format('YYYY-MM-DD');
      }
      _ApiLocalStorage2.default.requestData('table' + date + this.lic, 'api/legacy/sum-all', 'post', {
        'lic': this.lic,
        'period': date
      }, 900000).then(function (response) {
        _this.excelDate = date;
        _this.tableDataExe = response.values.exe;
        _this.tableDataOnline = response.values.online;
        _this.tableDataExeOnline = _this.calculateTable(_this.tableDataExe, _this.tableDataOnline);
        _this.prepareExportData();
        setTimeout(function () {
          _this.loader = false;
        }, 1);
      });
    },
    calculateTable: function calculateTable(exe, online) {
      var table = [];
      for (var i = 0; i < exe.length; i++) {
        table[i] = {
          date: exe[i].date,
          download: exe[i].download + online[i].download,
          first: exe[i].first + online[i].first,
          strong: exe[i].strong + online[i].strong,
          fills: exe[i].fills + online[i].fills,
          amount: exe[i].amount + online[i].amount
        };
      }
      return table;
    },
    calculateSum: function calculateSum(data) {
      var sum = {
        download: 0,
        first: 0,
        strong: 0,
        fills: 0,
        amount: 0
      };
      data.forEach(function (value) {
        sum.download += value.download;
        sum.first += value.first;
        sum.strong += value.strong;
        sum.fills += value.fills;
        sum.amount += value.amount;
      });
      return sum;
    },
    dateChange: function dateChange(date) {
      this.getTableData(date, 1);
    },
    prepareExportData: function prepareExportData() {
      var exe = this.tableDataExe;

      var sumAll = (0, _values2.default)(this.calculateSum(this.tableDataExe));
      var dataAll = [];
      for (var i = 0; i < this.tableDataExe.length; i++) {
        dataAll[i] = [exe[i]['date'], exe[i]['download'], exe[i]['first'], exe[i]['strong'], exe[i]['fills'], exe[i]['amount']];
      }
      for (var _i = 0; _i < dataAll.length; _i++) {
        for (var j = 0; j < dataAll[_i].length; j++) {
          dataAll[_i][j] = this.numberFormatter(dataAll[_i][j]);
        }
      }
      for (var _i2 = 0; _i2 < sumAll.length; _i2++) {
        sumAll[_i2] = this.numberFormatter(sumAll[_i2]);
      }
      sumAll.splice(0, 0, 'Suma');
      dataAll.push(sumAll);
      this.jsonData = dataAll;
    }
  },
  dateChange: function dateChange(date) {
    this.getTableData(date, 1);
  }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StatsCard = __webpack_require__(224);

var _StatsCard2 = _interopRequireDefault(_StatsCard);

var _BarChart = __webpack_require__(225);

var _BarChart2 = _interopRequireDefault(_BarChart);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    StatsCard: _StatsCard2.default,
    BarChart: _BarChart2.default
  },
  mounted: function mounted() {
    this.getCardsData('api/legacy/global-cards');
    this.dateRange = _ApiLocalStorage2.default.getDateRange();
  },
  data: function data() {
    return {
      loader: false,
      statsValue: {
        first: 0,
        strong: 0,
        upo_count: 0,
        upo_send_count: 0
      },
      dateRange: ''
    };
  },

  watch: {
    lic: function lic() {
      this.getCardsData('api/legacy/global-cards');
    }
  },
  computed: {
    lic: function lic() {
      return this.$store.getters.lic;
    }
  },
  methods: {
    getCardsData: function getCardsData(apiUrl) {
      var _this = this;

      this.loader = true;
      _ApiLocalStorage2.default.requestData('cardsFills' + this.lic, apiUrl, 'post', { 'lic': this.lic }, 900000).then(function (data) {
        _this.fillData(data);
        setTimeout(function () {
          _this.loader = false;
        }, 1);
      });
    },
    fillData: function fillData(data) {
      this.statsValue.first = data.first;
      this.statsValue.strong = data.strong;
      this.statsValue.upo_count = data.upo_count;
      this.statsValue.upo_send_count = data.upo_send_count;
    },
    dateChange: function dateChange(date) {
      _ApiLocalStorage2.default.setDateRange(date.split(','));
    }
  }
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(40);

var _axios2 = _interopRequireDefault(_axios);

var _User = __webpack_require__(26);

var _User2 = _interopRequireDefault(_User);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    labels: {
      type: Object,
      default: function _default() {
        return {
          title: 'Login',
          user: 'User',
          password: 'Password',
          button: 'Login'
        };
      }
    },
    apiUrl: {
      type: String,
      required: true
    },

    loginRoute: {
      type: String,
      default: 'oauth/token'
    },
    userRoute: {
      type: String,
      default: 'api/users/show-all'
    },
    clientId: {
      type: [Number, String],
      default: 2
    },
    secret: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      login: {
        user: '',
        password: ''
      },
      validationError: '',
      dialogVisible: true,
      buttonLoading: false
    };
  },

  computed: {
    loginUrl: function loginUrl() {
      return this.apiUrl + '/' + this.loginRoute;
    },
    userUrl: function userUrl() {
      return this.apiUrl + '/' + this.userRoute;
    }
  },
  methods: {
    getHeaders: function getHeaders(token) {
      return {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      };
    },
    loginClick: function loginClick() {
      this.buttonLoading = true;
      this.validationError = '';
    },
    handleLogin: function handleLogin() {
      var _this = this;

      var postData = {
        grant_type: 'password',
        client_id: this.clientId,
        client_secret: this.secret,
        username: this.login.user,
        password: this.login.password,
        scope: ''
      };

      var authUser = {};

      _axios2.default.post(this.loginUrl, postData).then(function (response) {
        authUser.access_token = response.data.access_token;
        authUser.refresh_token = response.data.refresh_token;
        var user = new _User2.default(authUser);
        user.getAccessToken();
        _ApiLocalStorage2.default.requestUserData('userDataOptions', _this.userUrl).then(function () {
          _this.$router.push({ name: 'Dashboard' });
        });
      }).catch(function (error) {
        _this.validationError = error.response.data.message;
        _this.buttonLoading = false;
      });
    }
  }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StatsCard = __webpack_require__(224);

var _StatsCard2 = _interopRequireDefault(_StatsCard);

var _BarChart = __webpack_require__(225);

var _BarChart2 = _interopRequireDefault(_BarChart);

var _ApiLocalStorage = __webpack_require__(16);

var _ApiLocalStorage2 = _interopRequireDefault(_ApiLocalStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    StatsCard: _StatsCard2.default,
    BarChart: _BarChart2.default
  },
  mounted: function mounted() {
    this.getCardsData('api/legacy/upo-cards');

    this.dateRange = _ApiLocalStorage2.default.getDateRange();
  },
  data: function data() {
    return {
      loader: false,
      statsValue: {
        all: 0,
        send: 0,
        upo: 0,
        ratio: 0
      },
      dateRange: ''
    };
  },

  watch: {
    lic: function lic() {
      this.getCardsData('api/legacy/upo-cards');
    }
  },
  computed: {
    lic: function lic() {
      return this.$store.getters.lic;
    }
  },
  methods: {
    getCardsData: function getCardsData(apiUrl) {
      var _this = this;

      this.loader = true;
      _ApiLocalStorage2.default.requestData('cards' + this.lic, apiUrl, 'post', {
        'lic': this.lic
      }, 900000).then(function (data) {
        _this.fillData(data);
        setTimeout(function () {
          _this.loader = false;
        }, 1);
      });
    },
    fillData: function fillData(data) {
      this.statsValue['1_card'] = data['1_card'];
      this.statsValue['2_card'] = data['2_card'];
      this.statsValue['3_card'] = data['3_card'];
      this.statsValue['4_card'] = data['4_card'];
    },
    dateChange: function dateChange(date) {
      _ApiLocalStorage2.default.setDateRange(date.split(','));
    }
  }
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditProfileForm = __webpack_require__(428);

var _EditProfileForm2 = _interopRequireDefault(_EditProfileForm);

var _UserCard = __webpack_require__(429);

var _UserCard2 = _interopRequireDefault(_UserCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    EditProfileForm: _EditProfileForm2.default,
    UserCard: _UserCard2.default
  }
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(27);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      user: {
        company: 'Paper Dashboard',
        username: 'michael23',
        email: '',
        lastName: 'Faker',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        postalCode: '',
        aboutMe: 'Oh so, your weak rhyme. You doubt I\'ll bother, reading into it.I\'ll probably won\'t, left to my own devicesBut that\'s the difference in our opinions.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + (0, _stringify2.default)(this.user));
    }
  }
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      details: [{
        title: '12',
        subTitle: 'Files'
      }, {
        title: '2GB',
        subTitle: 'Used'
      }, {
        title: '24,6$',
        subTitle: 'Spent'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    }
  }
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(425);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  methods: {
    getApiUrl: function getApiUrl() {
      return "https://stats-api2024.pit-format-online.pl";
    },
    getApiSecret: function getApiSecret() {
      return "Nb9lHhqa3oAdW6shvIiwrw0wQhKj7oDpoDS9FXJ2";
    }
  },
  components: {
    Login: _Login2.default
  }
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'stats-card',
  props: {
    type: '',
    icon: '',
    title: '',
    value: '',
    footerText: '',
    footerIcon: '',
    formatValue: ''
  }

};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BarChart = __webpack_require__(283);

var _BarChart2 = _interopRequireDefault(_BarChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Bar: _BarChart2.default
  },
  props: {
    url: '',
    time: '',
    localName: '',
    title: '',
    addMonths: {
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    type_from: {
      type: String,
      default: ''
    },
    dateRange: '',
    amountValue: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      displayLoading: false
    };
  },

  methods: {
    loadingEvent: function loadingEvent(load) {
      this.displayLoading = load;
    }
  }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  props: {
    id: '',
    dayDisplay: '',
    columns: Array,
    data: Array,
    dataType: '',
    type: {
      type: String,
      default: 'striped'
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    columnsNames: Array,
    sumRows: Array,
    sum: Object
  },
  watch: {
    data: function data() {}
  },
  computed: {
    tableClass: function tableClass() {
      return 'table-' + this.type;
    }
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {};
  },
  created: function created() {},


  props: {
    sum: Object,
    columns: Array,
    data: Array,
    type: {
      type: String,
      default: 'striped'
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    columnsNames: Array
  },
  watch: {
    data: function data() {}
  },
  computed: {
    tableClass: function tableClass() {
      return 'table-' + this.type;
    }
  },
  methods: {
    hasValue: function hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue: function itemValue(item, column) {
      return item[column.toLowerCase()];
    },
    checkAmountPermission: function checkAmountPermission(columnName) {
      return !((columnName === 'Kwota' || columnName === 'amount') && this.getPermission('hideAmounts'));
    }
  }
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  }
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      animate: true,
      animation: ''
    };
  },
  props: {
    'button_text': {
      type: String,
      default: 'Download Excel'
    },
    'data': {
      type: Array,
      required: true
    },
    'fields1': {
      type: Object
    },
    'fields2': {
      type: Array,
      required: true
    },

    'name': {
      type: String,
      default: 'data.xls'
    }
  },
  created: function created() {},
  computed: {
    id_name: function id_name() {
      var now = new Date().getTime();
      return 'export_' + now;
    }
  },
  methods: {
    emitXmlHeader: function emitXmlHeader() {
      var headerRow1 = '';
      if (this.fields1 !== undefined) {
        headerRow1 = '<tr  >\n';
        for (var colName in this.fields1) {
          headerRow1 += '  <th   colspan="' + this.fields1[colName] + '">\n';
          headerRow1 += colName + '\n';
          headerRow1 += '  </th>\n';
        }
        headerRow1 += '</tr>\n';
      }
      var headerRow2 = '<tr >\n';
      for (var ind in this.fields2) {
        headerRow2 += '  <th>\n';
        headerRow2 += this.fields2[ind] + '\n';
        headerRow2 += '  </th>\n';
      }
      headerRow2 += '</tr>\n';
      var style = '<style></style>';
      return '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Data</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' + style + '</head><body><table>\n' + '<thead>\n\n' + headerRow1 + headerRow2 + '</thead>\n\n' + '</tbody>\n';
    },
    emitXmlFooter: function emitXmlFooter() {
      return '\n</tbody>\n' + '</table>\n' + '</body>\n' + '</html>\n';
    },
    jsonToHtml: function jsonToHtml(jsonObject) {
      var row;
      var col;
      var xml;
      var data = (typeof jsonObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(jsonObject)) !== 'object' ? JSON.parse(jsonObject) : jsonObject;
      xml = this.emitXmlHeader();
      for (row = 0; row < data.length; row++) {
        xml += '<tr>\n';
        for (col in data[row]) {
          xml += '  <td>\n';
          xml += String(data[row][col]) + '\n';
          xml += '  </td>\n';
        }
        xml += '</tr>\n';
      }
      xml += this.emitXmlFooter();
      return xml;
    },
    generate_excel: function generate_excel() {
      var _this = this;

      this.$emit('onPrepareExportData');
      this.$nextTick(function () {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var base64 = function base64(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        };
        var a = document.getElementById(_this.id_name);
        a.href = uri + base64(_this.jsonToHtml(_this.data));
        a.download = _this.name;
      });
    }
  }
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'black', 'darkblue'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    },
    activeMain: function activeMain() {
      if (this.$route.path === '/panel/wplaty' || this.$route.path === '/panel/uruchomienia-wypelnienia') {
        return 'active';
      }
    },
    childFont: function childFont(child) {
      if (child) {
        return 'childFont';
      }
    }
  },
  data: function data() {
    return {
      linkHeight: 60,
      activeLinkIndex: 0,

      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false
    };
  },

  methods: {
    findActiveLink: function findActiveLink() {
      var _this = this;

      this.sidebarLinks.find(function (element, index) {
        var found = element.path === _this.$route.path;
        if (found) {
          _this.activeLinkIndex = index;
        }
        return found;
      });
    },
    amountAccessUrlPermission: function amountAccessUrlPermission(path) {
      return !(path === '/panel/wplaty' && this.getPermission('hideAmounts') || path === '/panel/statystyki-deklaracji' && this.getPermission('hideAmounts'));
    }
  },
  mounted: function mounted() {
    this.findActiveLink();
  },

  watch: {
    $route: function $route(newRoute, oldRoute) {
      this.findActiveLink();
    }
  }
};

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 96,
	"./af.js": 96,
	"./ar": 103,
	"./ar-dz": 97,
	"./ar-dz.js": 97,
	"./ar-kw": 98,
	"./ar-kw.js": 98,
	"./ar-ly": 99,
	"./ar-ly.js": 99,
	"./ar-ma": 100,
	"./ar-ma.js": 100,
	"./ar-sa": 101,
	"./ar-sa.js": 101,
	"./ar-tn": 102,
	"./ar-tn.js": 102,
	"./ar.js": 103,
	"./az": 104,
	"./az.js": 104,
	"./be": 105,
	"./be.js": 105,
	"./bg": 106,
	"./bg.js": 106,
	"./bm": 107,
	"./bm.js": 107,
	"./bn": 108,
	"./bn.js": 108,
	"./bo": 109,
	"./bo.js": 109,
	"./br": 110,
	"./br.js": 110,
	"./bs": 111,
	"./bs.js": 111,
	"./ca": 112,
	"./ca.js": 112,
	"./cs": 113,
	"./cs.js": 113,
	"./cv": 114,
	"./cv.js": 114,
	"./cy": 115,
	"./cy.js": 115,
	"./da": 116,
	"./da.js": 116,
	"./de": 119,
	"./de-at": 117,
	"./de-at.js": 117,
	"./de-ch": 118,
	"./de-ch.js": 118,
	"./de.js": 119,
	"./dv": 120,
	"./dv.js": 120,
	"./el": 121,
	"./el.js": 121,
	"./en-SG": 122,
	"./en-SG.js": 122,
	"./en-au": 123,
	"./en-au.js": 123,
	"./en-ca": 124,
	"./en-ca.js": 124,
	"./en-gb": 125,
	"./en-gb.js": 125,
	"./en-ie": 126,
	"./en-ie.js": 126,
	"./en-il": 127,
	"./en-il.js": 127,
	"./en-nz": 128,
	"./en-nz.js": 128,
	"./eo": 129,
	"./eo.js": 129,
	"./es": 132,
	"./es-do": 130,
	"./es-do.js": 130,
	"./es-us": 131,
	"./es-us.js": 131,
	"./es.js": 132,
	"./et": 133,
	"./et.js": 133,
	"./eu": 134,
	"./eu.js": 134,
	"./fa": 135,
	"./fa.js": 135,
	"./fi": 136,
	"./fi.js": 136,
	"./fo": 137,
	"./fo.js": 137,
	"./fr": 140,
	"./fr-ca": 138,
	"./fr-ca.js": 138,
	"./fr-ch": 139,
	"./fr-ch.js": 139,
	"./fr.js": 140,
	"./fy": 141,
	"./fy.js": 141,
	"./ga": 142,
	"./ga.js": 142,
	"./gd": 143,
	"./gd.js": 143,
	"./gl": 144,
	"./gl.js": 144,
	"./gom-latn": 145,
	"./gom-latn.js": 145,
	"./gu": 146,
	"./gu.js": 146,
	"./he": 147,
	"./he.js": 147,
	"./hi": 148,
	"./hi.js": 148,
	"./hr": 149,
	"./hr.js": 149,
	"./hu": 150,
	"./hu.js": 150,
	"./hy-am": 151,
	"./hy-am.js": 151,
	"./id": 152,
	"./id.js": 152,
	"./is": 153,
	"./is.js": 153,
	"./it": 155,
	"./it-ch": 154,
	"./it-ch.js": 154,
	"./it.js": 155,
	"./ja": 156,
	"./ja.js": 156,
	"./jv": 157,
	"./jv.js": 157,
	"./ka": 158,
	"./ka.js": 158,
	"./kk": 159,
	"./kk.js": 159,
	"./km": 160,
	"./km.js": 160,
	"./kn": 161,
	"./kn.js": 161,
	"./ko": 162,
	"./ko.js": 162,
	"./ku": 163,
	"./ku.js": 163,
	"./ky": 164,
	"./ky.js": 164,
	"./lb": 165,
	"./lb.js": 165,
	"./lo": 166,
	"./lo.js": 166,
	"./lt": 167,
	"./lt.js": 167,
	"./lv": 168,
	"./lv.js": 168,
	"./me": 169,
	"./me.js": 169,
	"./mi": 170,
	"./mi.js": 170,
	"./mk": 171,
	"./mk.js": 171,
	"./ml": 172,
	"./ml.js": 172,
	"./mn": 173,
	"./mn.js": 173,
	"./mr": 174,
	"./mr.js": 174,
	"./ms": 176,
	"./ms-my": 175,
	"./ms-my.js": 175,
	"./ms.js": 176,
	"./mt": 177,
	"./mt.js": 177,
	"./my": 178,
	"./my.js": 178,
	"./nb": 179,
	"./nb.js": 179,
	"./ne": 180,
	"./ne.js": 180,
	"./nl": 182,
	"./nl-be": 181,
	"./nl-be.js": 181,
	"./nl.js": 182,
	"./nn": 183,
	"./nn.js": 183,
	"./pa-in": 184,
	"./pa-in.js": 184,
	"./pl": 185,
	"./pl.js": 185,
	"./pt": 187,
	"./pt-br": 186,
	"./pt-br.js": 186,
	"./pt.js": 187,
	"./ro": 188,
	"./ro.js": 188,
	"./ru": 189,
	"./ru.js": 189,
	"./sd": 190,
	"./sd.js": 190,
	"./se": 191,
	"./se.js": 191,
	"./si": 192,
	"./si.js": 192,
	"./sk": 193,
	"./sk.js": 193,
	"./sl": 194,
	"./sl.js": 194,
	"./sq": 195,
	"./sq.js": 195,
	"./sr": 197,
	"./sr-cyrl": 196,
	"./sr-cyrl.js": 196,
	"./sr.js": 197,
	"./ss": 198,
	"./ss.js": 198,
	"./sv": 199,
	"./sv.js": 199,
	"./sw": 200,
	"./sw.js": 200,
	"./ta": 201,
	"./ta.js": 201,
	"./te": 202,
	"./te.js": 202,
	"./tet": 203,
	"./tet.js": 203,
	"./tg": 204,
	"./tg.js": 204,
	"./th": 205,
	"./th.js": 205,
	"./tl-ph": 206,
	"./tl-ph.js": 206,
	"./tlh": 207,
	"./tlh.js": 207,
	"./tr": 208,
	"./tr.js": 208,
	"./tzl": 209,
	"./tzl.js": 209,
	"./tzm": 211,
	"./tzm-latn": 210,
	"./tzm-latn.js": 210,
	"./tzm.js": 211,
	"./ug-cn": 212,
	"./ug-cn.js": 212,
	"./uk": 213,
	"./uk.js": 213,
	"./ur": 214,
	"./ur.js": 214,
	"./uz": 216,
	"./uz-latn": 215,
	"./uz-latn.js": 215,
	"./uz.js": 216,
	"./vi": 217,
	"./vi.js": 217,
	"./x-pseudo": 218,
	"./x-pseudo.js": 218,
	"./yo": 219,
	"./yo.js": 219,
	"./zh-cn": 220,
	"./zh-cn.js": 220,
	"./zh-hk": 221,
	"./zh-hk.js": 221,
	"./zh-tw": 222,
	"./zh-tw.js": 222
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","C:\\xampps\\xamp-7.4.29\\htdocs\\stats-application.pit-format-online.pl"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"C:\\xampps\\xamp-7.4.29\\htdocs\\stats-application.pit-format-online.pl","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 417 */,
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)
__webpack_require__(379)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  "data-v-12c6fc64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  "data-v-9a0745ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card buttonsDiv"
  }, [_c('el-checkbox', {
    staticClass: "correction-check",
    on: {
      "change": function($event) {
        return _vm.getTableData()
      }
    },
    model: {
      value: (_vm.correction),
      callback: function($$v) {
        _vm.correction = $$v
      },
      expression: "correction"
    }
  }, [_vm._v("Bez korekt\n                ")]), _vm._v(" "), _vm._l((_vm.months.length), function(monthNumber) {
    return _c('el-button', {
      class: {
        'el-button--primary': _vm.month == monthNumber - 1
      },
      on: {
        "click": function($event) {
          return _vm.changeDatePeriod(monthNumber - 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.months[monthNumber - 1]) + "\n                ")])
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd",
      "change": "loading"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('json-excel', {
    staticClass: "el-button el-button--default",
    attrs: {
      "data": _vm.jsonData,
      "fields1": _vm.json_fields1,
      "fields2": _vm.json_fields2,
      "name": ("raport_pitformat_" + _vm.lic + "_" + _vm.excelDate + ".xls")
    },
    on: {
      "onPrepareExportData": _vm.prepareExportData
    }
  }, [_vm._v("Eksport do excela\n\n\n                ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.disableOnline) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExeOnline, 'fills'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExeOnline, 'fills'),
      "dayDisplay": true,
      "dataType": "fills",
      "title": "Liczba wypełnień w podziale na deklaracje",
      "subTitle": "wersja instalacyjna + wersja online",
      "data": _vm.tableDataExeOnline
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.disableOnline) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExeOnline, 'amounts'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExeOnline, 'amounts'),
      "dayDisplay": true,
      "dataType": "amounts",
      "title": "Kwoty 1,5% w podziale na deklaracje",
      "subTitle": "wersja instalacyjna + wersja online",
      "data": _vm.tableDataExeOnline
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExe, 'amounts'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExe, 'amounts'),
      "id": "test2",
      "dayDisplay": true,
      "dataType": "amounts",
      "title": "Kwoty 1,5% w podziale na deklaracje",
      "subTitle": "wersja instalacyjna",
      "data": _vm.tableDataExe
    }
  })], 1)]), _vm._v(" "), (!_vm.disableOnline) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataOnline, 'amounts'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataOnline, 'amounts'),
      "id": "test",
      "dayDisplay": true,
      "dataType": "amounts",
      "title": "Kwoty 1,5% w podziale na deklaracje",
      "subTitle": "wersja online",
      "data": _vm.tableDataOnline
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExe, 'fills'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExe, 'fills'),
      "dayDisplay": true,
      "dataType": "fills",
      "title": "Liczba wypełnień w podziale na deklaracje",
      "subTitle": "wersja instalacyjna",
      "data": _vm.tableDataExe
    }
  })], 1)]), _vm._v(" "), (!_vm.disableOnline) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(this.tableDataOnline, 'fills'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataOnline, 'fills'),
      "dayDisplay": true,
      "dataType": "fills",
      "title": "Liczba wypełnień w podziale na deklaracje",
      "subTitle": "wersja online",
      "data": _vm.tableDataOnline
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.subTitle))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass
  }, [_c('thead', _vm._l((_vm.columnsNames), function(name) {
    return (_vm.checkAmountPermission(name)) ? _c('th', {
      staticClass: "text-center"
    }, [_vm._v("\n                " + _vm._s(name) + "\n            ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('tbody', {
    staticClass: "text-center"
  }, [_vm._l((_vm.data), function(item) {
    return _c('tr', _vm._l((_vm.columns), function(column) {
      return (_vm.hasValue(item, column) && _vm.checkAmountPermission(column)) ? _c('td', {
        class: {
          'text-right': column == 'amount'
        }
      }, [_vm._v(_vm._s(column == 'amount' ?
        _vm.numberFormatter(_vm.itemValue(item, column)) :
        _vm.numberFormatterThousand(_vm.itemValue(item, column))) + "\n                ")]) : _vm._e()
    }), 0)
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Suma")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.download)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.first)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.strong)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSep")(_vm.sum.fills)))]), _vm._v(" "), (!_vm.getPermission('hideAmounts')) ? _c('td', {
    staticClass: "text-right",
    class: {
      'bigAmountSize': _vm.sum.amount > 1000000
    }
  }, [_vm._v(_vm._s(_vm._f("filter")(_vm.sum.amount)))]) : _vm._e()])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('nav', {
    staticClass: "navbar navbar-ct-default",
    attrs: {
      "role": "navigation-demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Site title")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navigation-example-2"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "footer-demo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navigation-example-2"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-full-page section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("404 Not Found")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Wygląda na to, że ta strona nie istnieje")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n        © 2017, made with\n        "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by Paper admin\n      ")])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n      © Designed with\n      "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by\n      Pit"), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v("Format"), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v("Boys\n    ")])])])
}]}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card buttonsDiv"
  }, [_vm._l((_vm.months.length), function(monthNumber) {
    return _c('el-button', {
      class: {
        'el-button--primary': _vm.month == monthNumber - 1
      },
      on: {
        "click": function($event) {
          return _vm.getTableData(monthNumber - 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.months[monthNumber - 1]) + "\n                ")])
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd",
      "change": "loading"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), (!_vm.getExcelPermission()) ? _c('json-excel', {
    staticClass: "el-button el-button--default",
    attrs: {
      "data": _vm.jsonData,
      "fields1": _vm.json_fields1,
      "fields2": _vm.json_fields2,
      "name": ("raport_pitformat_" + _vm.lic + "_" + _vm.excelDate + ".xls")
    },
    on: {
      "onPrepareExportData": _vm.prepareExportData
    }
  }, [_vm._v("Eksport do excela\n                ")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.disableOnline) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('download-table', {
    attrs: {
      "columns-names": _vm.table1.names,
      "title": "Podsumowanie",
      "sub-title": "",
      "data": _vm.tableDataExeOnline,
      "columns": _vm.table1.columns,
      "sum": _vm.calculateSum(_vm.tableDataExeOnline)
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('download-table', {
    attrs: {
      "columns-names": _vm.table1.names,
      "title": "Instalacyjna",
      "sub-title": "",
      "data": _vm.tableDataExe,
      "columns": _vm.table1.columns,
      "sum": _vm.calculateSum(_vm.tableDataExe)
    }
  })], 1)]), _vm._v(" "), (!_vm.disableOnline) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('download-table', {
    attrs: {
      "columns-names": _vm.table1.names,
      "title": "Online",
      "sub-title": "",
      "data": _vm.tableDataOnline,
      "columns": _vm.table1.columns,
      "sum": _vm.calculateSum(_vm.tableDataOnline)
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.subTitle))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width",
    attrs: {
      "id": "table"
    }
  }, [_c('table', {
    staticClass: "table",
    class: _vm.tableClass,
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', {
    staticClass: "text-right"
  }, [_c('tr', [(_vm.dayDisplay) ? _c('th', [_vm._v("Dzień")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT28")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT36")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT36l")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT37")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT38")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("PIT39")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Suma")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-center"
  }, [_vm._l((_vm.data), function(item, index) {
    return _c('tr', [(_vm.dayDisplay) ? _c('td', [_vm._v(" " + _vm._s(item.day))]) : _vm._e(), _vm._v(" "), _vm._l((item[_vm.dataType]), function(declarationValue) {
      return _c('td', {
        staticClass: "text-right"
      }, [_vm._v("\n                    " + _vm._s(_vm.dataType == "fills" ? declarationValue : _vm.numberFormatter(declarationValue)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.dataType == "fills" ? _vm.sumRows[index] : _vm.numberFormatter(_vm.sumRows[index])) + "\n                ")])], 2)
  }), _vm._v(" "), _c('tr', {
    staticClass: "text-right"
  }, [_c('td', {
    staticClass: "text-center"
  }, [_vm._v("Suma")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.pit28) : _vm.numberFormatter(_vm.sum.pit28)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.pit36) : _vm.numberFormatter(_vm.sum.pit36)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.pit36l) : _vm.numberFormatter(_vm.sum.pit36l)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.pit37) : _vm.numberFormatter(_vm.sum.pit37)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.pit38) : _vm.numberFormatter(_vm.sum.pit38)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.pit39) : _vm.numberFormatter(_vm.sum.pit39)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.dataType == 'fills' ? _vm.numberFormatterThousand(_vm.sum.summary) : _vm.numberFormatter(_vm.sum.summary)) + "\n                ")])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('side-bar', {
    attrs: {
      "type": "sidebar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('top-navbar'), _vm._v(" "), _c('dashboard-content', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSidebar($event)
      }
    }
  }), _vm._v(" "), _c('content-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-user"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.details), function(info, index) {
    return _c('div', {
      class: _vm.getClasses(index)
    }, [_c('h5', [_vm._v(_vm._s(info.title) + "\n          "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(info.subTitle))])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/background.jpg",
      "alt": "..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "description text-center"
  }, [_vm._v("\n      \"I like the way you work it\n      "), _c('br'), _vm._v(" No diggity\n      "), _c('br'), _vm._v(" I wanna bag it up\"\n    ")])])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    class: {
      toggled: _vm.$sidebar.showSidebar
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand"
  }, [_vm._v(_vm._s(_vm.routeName))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('div', {
    staticClass: "selectBoxMargin"
  }, [_c('span', {
    staticClass: "licName"
  }, [_vm._v(_vm._s(_vm.licName))]), _vm._v(" "), (_vm.checkLicensesLength()) ? _c('label', {
    staticClass: "licLabel"
  }, [_vm._v("Wybierz licencje")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": !_vm.checkLicensesLength(),
      "placeholder": "Licencja",
      "change": _vm.changeLicense(_vm.license)
    },
    model: {
      value: (_vm.license),
      callback: function($$v) {
        _vm.license = $$v
      },
      expression: "license"
    }
  }, _vm._l((_vm.licenses), function(item) {
    return _c('el-option', {
      key: item.lic,
      attrs: {
        "value": item.lic
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('i', {
    staticClass: "ti-close"
  }), _vm._v(" "), _c('p', [_vm._v("\n                            Logout\n                        ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "warning",
      "icon": "ti-cup",
      "title": "Pierwsze uruchomienia aplikacji",
      "value": _vm.statsValue.first,
      "footerText": "test",
      "formatValue": "false",
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "success",
      "icon": "ti-wallet",
      "title": "Dodanie nowego podatnika",
      "value": _vm.statsValue.strong,
      "formatValue": "false",
      "footerText": "test",
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "danger",
      "icon": "ti-info",
      "title": "Suma wszystkich wypełnionych deklaracji",
      "value": _vm.statsValue.upo_count,
      "formatValue": "false",
      "footerText": "test",
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "info",
      "icon": "ti-email",
      "title": "Liczba wysłanych eDeklaracji",
      "value": _vm.statsValue.upo_send_count,
      "footerText": "test",
      "formatValue": "false",
      "footerIcon": "ti-timer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card cardText"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                    Wybierz zakres dla wykresów\n                    "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Pierwsze uruchomienia",
      "url": "api/legacy/first",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "first",
      "amountValue": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Pierwsze dodanie podatnika",
      "url": "api/legacy/strong",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "strong",
      "amountValue": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wszystkich wypełnionych deklaracji",
      "url": "api/legacy/wyp",
      "type": "count",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "wyp",
      "amountValue": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Liczba wysłanych eDeklaracji",
      "url": "api/legacy/upo",
      "time": "200000",
      "type": "count",
      "dateRange": _vm.dateRange,
      "type_form": "pc_send",
      "localName": "sendCount",
      "amountValue": false
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Podane w naszych statystykach "), _c('strong', [_vm._v("wpłaty 1,5% są kwotami szacunkowymi")]), _vm._v(",\n                    wynikającymi z zastosowania odpowiednich współczynników opartych\n                    na danych statystycznych z poprzednich lat, które\n                    generuje program PIT Format. Brane są pod uwagę kwoty 1,5% wskazane przez podatników w\n                    deklaracjach: "), _c('strong', [_vm._v("zapisanych jako pdf, wydrukowanych oraz wysłanych jako\n                        eDeklaracja")]), _vm._v(".\n\n                    Dane te mają charakter poglądowy, ponieważ nie jest możliwy pełny i dokładny\n                    monitoring wpłat 1,5%, np. nastąpiło wydrukowanie czy zapisanie pdf deklaracji w programie, ale\n                    nie dostarczono jej finalnie do urzędu skarbowego."), _c('br'), _vm._v("\n                    Wg naszych analiz wskazane kwoty mogą mieć odchylenie rzędu -/+ 10 %.\n                ")])
}]}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.label) ? _c('label', [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control border-input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    attrs: {
      "data-background-color": _vm.backgroundColor,
      "data-active-color": _vm.activeColor
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper",
    attrs: {
      "id": "style-3"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('ul', {
    class: _vm.navClasses,
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.sidebarLinks), function(link, index) {
    return (_vm.amountAccessUrlPermission(link.path)) ? _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('i', {
      class: link.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(link.name))])])])])]) : _vm._e()
  }), 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": ""
    }
  })]), _vm._v("\n                Pit Format Statistics\n            ")])])
}]}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-fullheight is-dark is-bold"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Pit Format Statistics")]), _vm._v(" "), _c('form', {
    staticClass: "loginInputMargin",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleLogin($event)
      }
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Login"
    },
    model: {
      value: (_vm.login.user),
      callback: function($$v) {
        _vm.$set(_vm.login, "user", $$v)
      },
      expression: "login.user"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Hasło"
    },
    model: {
      value: (_vm.login.password),
      callback: function($$v) {
        _vm.$set(_vm.login, "password", $$v)
      },
      expression: "login.password"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "label-error",
    domProps: {
      "textContent": _vm._s(_vm.validationError)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control text-right"
  }, [_c('el-button', {
    attrs: {
      "native-type": "submit",
      "loading": _vm.buttonLoading
    },
    on: {
      "click": _vm.loginClick
    }
  }, [_vm._v("Zaloguj\n                    ")])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Podaj ",
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Last Name",
      "placeholder": "Last Name"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill btn-wd",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfile($event)
      }
    }
  }, [_vm._v("\n          Update Profile\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Edit Profile")])])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "warning",
      "icon": "ti-cup",
      "title": "Suma szacowanych wpłat 1,5% łącznie",
      "value": _vm.statsValue['1_card'],
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "success",
      "icon": "ti-wallet",
      "title": "Suma wpłat 1,5% z drukowanych deklaracji",
      "value": _vm.statsValue['2_card'],
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "danger",
      "icon": "ti-info",
      "title": "Suma wpłat 1,5% z eDeklaracji",
      "value": _vm.statsValue['3_card'],
      "footerIcon": "ti-timer"
    }
  }), _vm._v(" "), _c('stats-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "type": "info",
      "icon": "ti-email",
      "title": "Średnia kwota 1,5% (kwota / wypełnienie)",
      "value": _vm.statsValue['4_card'],
      "footerIcon": "ti-timer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card cardText"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                    Wybierz zakres dla wykresów\n                    "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wpłat 1,5%",
      "url": "api/legacy/upo",
      "time": "200000",
      "localName": "all",
      "dateRange": _vm.dateRange,
      "type": "sum",
      "amountValue": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wpłat 1,5% z drukowanych deklaracji",
      "url": "api/legacy/upo",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "send",
      "type": "sum",
      "type_from": "pc_send",
      "amountValue": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Suma wpłat 1,5% z eDeklaracji",
      "url": "api/legacy/upo",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "localName": "upo",
      "type": "sum",
      "type_from": "pc_upo",
      "amountValue": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "title": "Średnia kwota 1,5% (kwota/wypełnienie) ",
      "url": "api/legacy/upo-ratio",
      "time": "200000",
      "dateRange": _vm.dateRange,
      "type": "sum",
      "localName": "ratio",
      "amountValue": true
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Podane w naszych statystykach "), _c('strong', [_vm._v("wpłaty 1,5% są kwotami szacunkowymi")]), _vm._v(",\n                    wynikającymi z zastosowania odpowiednich współczynników opartych\n                    na danych statystycznych z poprzednich lat, które\n                    generuje program PIT Format. Brane są pod uwagę kwoty 1,5% wskazane przez podatników w\n                    deklaracjach: "), _c('strong', [_vm._v("zapisanych jako pdf, wydrukowanych oraz wysłanych jako\n                        eDeklaracja")]), _vm._v(".\n\n                    Dane te mają charakter poglądowy, ponieważ nie jest możliwy pełny i dokładny\n                    monitoring wpłat 1,5%, np. nastąpiło wydrukowanie czy zapisanie pdf deklaracji w programie, ale\n                    nie dostarczono jej finalnie do urzędu skarbowego."), _c('br'), _vm._v("\n                    Wg naszych analiz wskazane kwoty mogą mieć odchylenie rzędu -/+ 10 %.\n\n\n                ")])
}]}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "icon-big text-center",
    class: ("icon-" + _vm.type)
  }, [_c('i', {
    class: _vm.icon
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-right col-xs-7 numbers"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _vm._v("\n                    " + _vm._s(_vm.formatValue ? _vm.numberFormatterThousand(_vm.value) : _vm.numberFormatter(_vm.value)) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.displayLoading),
      expression: "displayLoading"
    }],
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card  pt-20"
  }, [_c('span', {
    staticClass: "chartTitle"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('bar', {
    attrs: {
      "range": _vm.dateRange,
      "localName": _vm.localName,
      "time": _vm.time,
      "url": _vm.url,
      "addMonths": _vm.addMonths,
      "type": _vm.type,
      "type_from": _vm.type_from,
      "amountValue": _vm.amountValue
    },
    on: {
      "loader": _vm.loadingEvent
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('user-card')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('edit-profile-form')], 1)])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "id": _vm.id_name
    },
    on: {
      "click": _vm.generate_excel
    }
  }, [_vm._t("default", [_vm._v("\n        " + _vm._s(_vm.button_text) + "\n    ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('login', {
    attrs: {
      "api-url": _vm.getApiUrl(),
      "secret": _vm.getApiSecret()
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('side-bar', {
    attrs: {
      "type": "navbar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', [_c('i', {
    staticClass: "ti-settings"
  }), _vm._v(" "), _c('p', [_vm._v("Logout")])])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  })])])], 1)
},staticRenderFns: []}

/***/ })
],[285]);


// WEBPACK FOOTER //
// static/js/app.fdb1bb5cbedfc21669af.js